export const iconFontAwesomeAstronomyShuttleSpace = (
	<i className="fa-solid fa-shuttle-space"></i>
);
